export var initToggle = function (column) {
    column.getElement().querySelectorAll('[data-toggle="column"]').forEach(function (el) {
        el.addEventListener('click', function (e) { return column.toggle(); });
        el.style.cursor = 'pointer';
    });
};
